import React from 'react';
import { useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';

import { includes } from 'lodash';
import { TRR_CHILE } from '~/constants/modules';
import { MODULO_FERROVIA } from '~/constants/modules';
import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';

/** IMPORT PAGES */
import RecalculaTurno from '~/pages/RecalculaTurno';
import AlteracaoCentroCusto from '~/pages/AlteracaoCentroCusto';
import TiposDeEquipamentosVeiculo from '~/pages/Cadastro/TiposDeEquipamentosVeiculo';

import RecebimentoAreiaNf from '~/pages/Operacao/RecebimentoAreiaNf';
import TransferenciaAreiaSilo from '~/pages/Operacao/TransferenciaAreiaSilo';
import AfericaoAreiaSilo from '~/pages/Operacao/AfericaoAreiaSilo';
import EstoqueAreia from '~/pages/Operacao/EstoqueAreia';
import ApuracaoEstoqueAreia from '~/pages/Operacao/ApuracaoEstoqueAreia';
import AuditoriaSistemas from '~/pages/AuditoriaSistemas';
import BlankPage from '~/pages/BlankPage';
import CadastroDvec from '~/pages/Cadastro/CadastroDvec';
import CentroCusto from '~/pages/Cadastro/CentroCusto';
import Contrato from '~/pages/Cadastro/Contrato';
import Distribuidora from '~/pages/Cadastro/Distribuidora';
import EmpresaCliente from '~/pages/Cadastro/EmpresaCliente';
import EmpresaVeiculo from '~/pages/Cadastro/EmpresaVeiculo';
import Gerencias from '~/pages/Cadastro/Gerencias';
import Locomotiva from '~/pages/Cadastro/Locomotiva';
import MarcasVeiculo from '~/pages/Cadastro/MarcasVeiculo';
import ModeloVeiculo from '~/pages/Cadastro/ModeloVeiculo';
import Motorista from '~/pages/Cadastro/Motorista';
import Operacao from '~/pages/Cadastro/Operacao';
import PerfilFrentista from '~/pages/Cadastro/PerfilFrentista';
import Perfis from '~/pages/Cadastro/Perfis';
import Safras from '~/pages/Cadastro/Safras';
import Transportadora from '~/pages/Cadastro/Transportadora';
import Usuario from '~/pages/Cadastro/Usuario';
import Veiculo from '~/pages/Cadastro/Veiculo';
import Corredor from '~/pages/Cadastro/Corredor';
import CausasManutencoes from '~/pages/CausasManutencoes';
import ChangesRelease from '~/pages/ChangesRelease';
import Checkliberadoparaintegracao from '~/pages/Checkliberadoparaintegracao';
import Checkxmlnfrecebimentonf from '~/pages/Checkxmlnfrecebimentonf';
import ClienteConfig from '~/pages/ClienteConfig';
import AlarmeSistema from '~/pages/Configuracao/AlarmeSistema';
import ConfiguracaoAlarmeTanque from '~/pages/Configuracao/AlarmeTanque';
import Arqueacao from '~/pages/Configuracao/Arqueacao';
import Bico from '~/pages/Configuracao/Bico';
import PitStopExcecaoMeta from '~/pages/Configuracao/PitStopExcecaoMeta';
import CercasVirtuais from '~/pages/Configuracao/CercasVirtuais';
import Comboio from '~/pages/Configuracao/Comboio';
import InversorFrequencia from '~/pages/Configuracao/InversorFrequencia';
import JustificativaAlteracaoEncerrante from '~/pages/Configuracao/JustificativaAlteracaoEncerrante';
import JustificativaContingencia from '~/pages/Configuracao/JustificativaContingencia';
import JustificativaTrocaModoOperacional from '~/pages/Configuracao/JustificativaTrocaModoOperacional';
import LinhaAbastecimento from '~/pages/Configuracao/LinhaAbastecimento';
import Medidores from '~/pages/Configuracao/Medidores';
import PitStopJustificativa from '~/pages/Configuracao/PitStopJustificativa';
import PitStopRegra from '~/pages/Configuracao/PitStopRegra';
import PitStopTipoAreia from '~/pages/Configuracao/PitStopTipoAreia';
import Posto from '~/pages/Configuracao/Posto';
import Preset from '~/pages/Configuracao/Preset';
import Produto from '~/pages/Configuracao/Produto';
import ConversorEntradaSaida from '~/pages/Configuracao/ConversorEntradaSaida';
import TanqueFisico from '~/pages/Configuracao/TanqueFisico';
import TanqueVirtual from '~/pages/Configuracao/TanqueVirtual';
import Terminal from '~/pages/Configuracao/Terminal';
import Dashboard from '~/pages/Dashboard';
import DashboardContingencia from '~/pages/DashboardContingencia';
import DashboardDvec from '~/pages/Dashboards/DashboardDvec';
import DashboardVisaoGeral from '~/pages/Dashboards/DashboardVisaoGeral';
import DashboardVisaoGeralFullscreen from '~/pages/Dashboards/DashboardVisaoGeral/Fullscren';
import Demo from '~/pages/Demo';
import EdicaoAlinhamentoTanque from '~/pages/EdicaoOperacao/AlinhamentoTanque';
import EdicaoRecebimento from '~/pages/EdicaoOperacao/Recebimento';
import EdicaoTransferencia from '~/pages/EdicaoOperacao/Transferencia';
import EdicaoTrocaTanque from '~/pages/EdicaoOperacao/TrocaTanque';
import Turno from '~/pages/EdicaoOperacao/Turno';
import NotFound from '~/pages/errors/NotFound';
import EstoquePostoMonitor from '~/pages/EstoquePostoMonitor';
import EstoquePostoMonitorFullscreen from '~/pages/EstoquePostoMonitor/fullscreen';
import EstoqueProduto from '~/pages/EstoqueProduto';
import Fechamentolmc from '~/pages/Fechamentolmc';
import FotoNF from '~/pages/FotoNF';
import AderenciaProduto from '~/pages/IndicadoresOperacao/AderenciaProduto';
import ResumoSLA from '~/pages/IndicadoresOperacao/ResumoSLA';
import PerdaSLA from '~/pages/IndicadoresOperacao/PerdaSLA';
import Localidade from '~/pages/Localidade';
import MensagemSistemaEquipamento from '~/pages/MensagemSistema/MensagemSistemaEquipamento';
import MensagemSistemaEquipamentoPosto from '~/pages/MensagemSistema/MensagemSistemaEquipamentoPosto';
import MensagemSistemaFrentista from '~/pages/MensagemSistema/MensagemSistemaFrentista';
import MensagemSistemaMotorista from '~/pages/MensagemSistema/MensagemSistemaMotorista';
import MensagemSistemaoEquipamentoKm from '~/pages/MensagemSistema/MensagemSistemaoEquipamentoKm';
import MensagemSistemaOperacaoAgricola from '~/pages/MensagemSistema/MensagemSistemaOperacaoAgricola';
import MensagemSistemaPosto from '~/pages/MensagemSistema/MensagemSistemaPosto';
import ModulosCliente from '~/pages/ModulosCliente';
import Notafiscalrecebida from '~/pages/Notafiscalrecebida';
import Abastecimento from '~/pages/Operacao/Abastecimento';
import AbastecimentoExterno from '~/pages/Operacao/AbastecimentoExterno';
import AfericaoDvec from '~/pages/Operacao/AfericaoDvec';
import OperacaoAlinhamentoTanque from '~/pages/Operacao/AlinhamentoTanque';
import ArqueacaoAutomatica from '~/pages/Operacao/ArqueacaoAutomatica/index';
import ArqueacaoTanque from '~/pages/Operacao/ArqueacaoTanque';
import OperacaoBatelada from '~/pages/Operacao/Batelada';
import DesbloqueioIrregularidadeDbic from '~/pages/Operacao/DesbloqueioDbic';
import OperacaoDiagnostico from '~/pages/Operacao/Diagnostico';
import EstoqueGeralProstosProdutos from '~/pages/Operacao/EstoqueGeralPostosProdutos';
import OperacaoEstoquePosto from '~/pages/Operacao/EstoquePosto';
import OperacaoEstoqueTanque from '~/pages/Operacao/EstoqueTanque';
import OperacaoGeolocalizacao from '~/pages/Operacao/Geolocalizacao';
import OperacaoLimpezaDvec from '~/pages/Operacao/LimpezaDvec';
import OperacaoLimpezaTag from '~/pages/Operacao/LimpezaTag';
import LogsDescarregamentos from '~/pages/Operacao/LogsDescarregamentos';
import ManutencaoDvec from '~/pages/Operacao/ManutencaoDvec';
import OperacaoMedicaoTemperatura from '~/pages/Operacao/MedicaoTemperatura';
import OperacaoDreno from '~/pages/Operacao/Dreno';
import RelDrenagemTanque from '~/pages/RelDrenagemTanque';
import PrecoProduto from '~/pages/Operacao/PrecoProduto';
import OperacaoRecebimentoNf from '~/pages/Operacao/RecebimentoNf';
import SinoticoDescarregamento from '~/pages/Operacao/SinoticoDescarregamento';
import SinoticoDescarregamentoPreset from '~/pages/Operacao/SinoticoDescarregamento/pages/SinoticoDescarregamentoPreset';
import SinoticoDescarregamentoFull from '~/pages/Operacao/SinoticoDescarregamentoFull';
import TagComRestricao from '~/pages/Operacao/TagComRestricao';

import OperacaoTotalizadorVeiculo from '~/pages/Operacao/TotalizadorVeiculo';
import Transferencia from '~/pages/Operacao/Transferencia';
import TrocaTanque from '~/pages/Operacao/TrocaTanque';
import OperacaoTurno from '~/pages/Operacao/Turno';
import OperacaoVazaonaoAutorizada from '~/pages/Operacao/VazaoNaoAutorizada';
import OperacaoAfericao from '~/pages/OperacaoAfericao';
import OperacaoBateriaDbic from '~/pages/OperacaoBateriaDbic';
import OperacaoLubrificacao from '~/pages/OperacaoLubrificacao';
import OperacaoRecebimento from '~/pages/OperacaoRecebimento';
import PitStop from '~/pages/PitStop';

import Raizenerrologintegracao from '~/pages/Raizenerrologintegracao';
import Relabastecimento from '~/pages/Relabastecimento';
import RelAbastecimentoA2VF from '~/pages/RelAbastecimentoA2VF';
import Relabastecimentocontingencia from '~/pages/Relabastecimentocontingencia';
import RelAbastecimentoFinal from '~/pages/RelAbastecimentoFinal';
import Relafericao from '~/pages/Relafericao';
import RelAfericaoDvec from '~/pages/RelAfericaoDvec';
import Relalarmesistema from '~/pages/Relalarmesistema';
import RelAlinhamentoTanque from '~/pages/RelAlinhamentoTanque';
import Relalteracaoencerrante from '~/pages/Relalteracaoencerrante';
import Relalteracaoestoqueproduto from '~/pages/Relalteracaoestoqueproduto';
import Relalteracaomodooperacional from '~/pages/Relalteracaomodooperacional';
import DVECDanificadoParado from '~/pages/Relatorio/DVECDanificadoParado';
import ConsultaAvancada from '~/pages/RelConsultaAvancada';
import RelCotaContrato from '~/pages/RelCotaContrato';
import RelCotaEmpresaVeiculo from '~/pages/RelCotaEmpresaVeiculo';
import RelCotaVeiculo from '~/pages/RelCotaVeiculo';
import RelDesempenhoLubrificacaoVeiculo from '~/pages/RelDesempenhoLubrificacaoVeiculo';
import RelDesempenhoModeloVeiculo from '~/pages/RelDesempenhoModeloVeiculo';
import RelDesempenhoMotorista from '~/pages/RelDesempenhoMotorista';
import RelDesempenhoOperacao from '~/pages/RelDesempenhoOperacao';
import ReldesempenhoVeiculo from '~/pages/ReldesempenhoVeiculo';
import ReldiferencaEncerrante from '~/pages/ReldiferencaEncerrante';
import RelEntregaProduto from '~/pages/RelEntregaProduto';
import RelEquipamento from '~/pages/RelEquipamento';
import Relextratoproduto from '~/pages/Relextratoproduto';
import RelHistoricoCadDVEC from '~/pages/RelHistoricoCadDVEC';
import RelHistoricoCadTAG from '~/pages/RelHistoricoCadTAG';
import RelInstalacaoPin from '~/pages/RelInstalacaoPin';
import Rellmc from '~/pages/Rellmc';
import Rellubrificacao from '~/pages/Rellubricacao';
import RelMedicao from '~/pages/RelMedicao';
import RelPitStopQuantidade from '~/pages/RelPitStopQuantidade';
import RelPitStopTempos from '~/pages/RelPitStopTempos';
import RelPitStopControleAbastecimento from '~/pages/RelPitStopControleAbastecimento';
import RelPitStopRecebimentoAreia from '~/pages/RelPitStopRecebimentoAreia';
import RelPitStopExtratoAreia from '~/pages/RelPitStopExtratoAreia';
import RelPrecoProduto from '~/pages/RelPrecoProduto';
import Relrecebimento from '~/pages/Relrecebimento';
import Relrecebimentonf from '~/pages/Relrecebimentonf';
import Relrecebimentonf20 from '~/pages/Relrecebimentonf20';
import RelRegimeEspecialAnglo from '~/pages/RelRegimeEspecialAnglo';
import RelResumoGeral from '~/pages/RelResumoGeral';
import Relresumooperacao from '~/pages/Relresumooperacao';
import Relresumoturno from '~/pages/Relresumoturno';
import Reltransferencia from '~/pages/Reltransferencia';
import RelTrocaBateriaDbic from '~/pages/RelTrocaBateriaDbic';
import RelTrocaTanque from '~/pages/RelTrocaTanque';
import Relvazaonaoautorizada from '~/pages/RelvazaonaoAutorizada';
import RelVeiculosAtivos from '~/pages/Relveiculosativos';
import RelPitStopFatorConsumo from '~/pages/RelPitStopFatorConsumo';

// import Uploadplanilhacliente from '~/pages/Uploadplanilhacliente';

// import Relalarmesistema from '~/pages/Relalarmesistema';
// import SignIn from '~/pages/SignIn';
import Retransregisintegracao from '~/pages/Retransregisintegracao';
import SignIn from '~/pages/SignIn';
import Uploadplanilhacliente from '~/pages/Uploadplanilhacliente';
import RelMovimentacaoManualParaIntegracao from '~/pages/RelMovimentacaoManualParaIntegracao';
import RelRaizenErrologIntegracao from '~/pages/RelRaizenErrologIntegracao';
import Route from './Route';
import PitstopEstoqueAreia from '~/pages/Configuracao/PitStopEstoqueAreia';

export default function Routes() {
  const modules = useSelector((state) => state.user.modules);
  const hasModule = (moduleCode) => includes(modules, moduleCode);

  return (
    <Switch>
      <Route path="/" exact component={SignIn} />

      <Route
        path="/recalculaturno"
        component={RecalculaTurno}
        title="s.menu.configabastek.recalculaturno"
        isPrivate
        exact
      />
      <Route
        path="/alteracc"
        component={AlteracaoCentroCusto}
        title="s.menu.operacao.alteracaocentrocusto"
        isPrivate
        exact
      />

      <Route
        path="/tiposdeequipamentosveiculo"
        component={TiposDeEquipamentosVeiculo}
        title="s.menu.cadastro.tiposdeequipamentosveiculo"
        isPrivate
        exact
      />

      <Route
        path="/relpitstopfatorconsumo"
        component={RelPitStopFatorConsumo}
        title="s.menu.relatorio.relpitstopfatorconsumo"
        isPrivate
        exact
      />

      {hasModule(MODULO_CUSTOMIZACAO_RUMO) && (
        <Route
          path="/relpitstopcontroleabastecimento"
          component={RelPitStopControleAbastecimento}
          title="s.relatorio.pitstopcontroleabastecimento"
          isPrivate
          exact
        />
      )}

      {hasModule(MODULO_FERROVIA) && (
        <Route
          path="/relpitstoprecebimentoareia"
          component={RelPitStopRecebimentoAreia}
          title="s.relatorio.pitstoprecebimentoareia"
          isPrivate
          exact
        />
      )}

      <Route
        path="/relpitstopextratoareia"
        component={RelPitStopExtratoAreia}
        title="s.menu.relatorio.relpitstopextratoareia"
        isPrivate
        exact
      />

      <Route
        path="/relmovimentacaomanualparaintegracao"
        component={RelMovimentacaoManualParaIntegracao}
        title=""
        isPrivate
        exact
      />

      <Route
        path="/corredor"
        component={Corredor}
        title="s.menu.cadastro.corredor"
        isPrivate
        exact
      />

      <Route
        path="/retransregisintegracao"
        component={Retransregisintegracao}
        title="s.menu.operacao.retransregisintegracao"
        isPrivate
        exact
      />

      <Route
        path="/relraizenerrologintegracao"
        component={RelRaizenErrologIntegracao}
        title="s.menu.relatorio.relraizenerrologintegracao"
        isPrivate
        exact
      />

      <Route
        path="/raizenerrologintegracao"
        component={Raizenerrologintegracao}
        title="s.menu.operacao.raizenerrologintegracao"
        isPrivate
        exact
      />

      <Route
        path="/checkxmlnfrecebimentonf"
        component={Checkxmlnfrecebimentonf}
        title="s.menu.operacao.checkxmlnfrecebimentonf"
        isPrivate
        exact
      />

      <Route path="/rellmc" component={Rellmc} title="" isPrivate exact />

      <Route
        path="/dashboardvisaogeral"
        component={DashboardVisaoGeral}
        title="s.menu.dashboard.visaogeral"
        isPrivate
        exact
      />

      <Route
        path="/dashboardvisaogeral_fullscreen"
        component={DashboardVisaoGeralFullscreen}
        title="s.menu.dashboard.visaogeral"
        isPrivate
        fullScreen
        exact
      />

      <Route
        path="/fechamentolmc"
        component={Fechamentolmc}
        title="s.menu.operacao.fechamentolmc"
        isPrivate
        exact
      />

      <Route
        path="/transportadoras"
        component={Transportadora}
        title="s.menu.cadastro.transportadora"
        isPrivate
        exact
      />

      <Route
        path="/distribuidoras"
        component={Distribuidora}
        title="s.relatorio.geral.distribuidora"
        isPrivate
        exact
      />

      <Route
        path="/checkliberadoparaintegracao"
        component={Checkliberadoparaintegracao}
        title="s.menu.operacao.checkliberadoparaintegracao"
        isPrivate
        exact
      />

      <Route
        path="/operacaoarqueacaotanque"
        component={ArqueacaoTanque}
        title="s.menu.operacao.arqueacaotanque"
        isPrivate
        exact
      />

      <Route
        path="/relpitstoptempos"
        component={RelPitStopTempos}
        title="s.menu.relatorio.pitstoptempos"
        isPrivate
        exact
      />

      <Route
        path="/indicadoroperacaoresumosla"
        component={ResumoSLA}
        title="s.menu.indicadoroperacao.resumosla"
        isPrivate
        exact
      />

      <Route
        path="/inversoresfrequencias"
        component={InversorFrequencia}
        title="s.menu.configuracao.inversoresfrequencias"
        isPrivate
        exact
      />

      <Route
        path="/presets"
        component={Preset}
        title="s.menu.configuracao.preset"
        isPrivate
        exact
      />

      <Route
        path="/pitstopregras"
        component={PitStopRegra}
        title="s.menu.configuracao.pitstop.regra"
        isPrivate
        exact
      />

      <Route
        path="/tiposareia"
        component={PitStopTipoAreia}
        title="s.menu.configuracao.pitstop.tiposareia"
        isPrivate
        exact
      />

      <Route
        path="/estoqueareia"
        component={PitstopEstoqueAreia}
        title="s.menu.configuracao.pitstop.estoqueareia"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemaoequipamentokm"
        component={MensagemSistemaoEquipamentoKm}
        title="s.menu.cadastro.mensagemsistemaoequipamentokm"
        isPrivate
        exact
      />

      <Route
        path="/excecaometa"
        component={PitStopExcecaoMeta}
        title="s.menu.configuracao.pitstop.excecaometa"
        isPrivate
        exact
      />

      <Route
        path="/indicadoroperacaoperdasla"
        component={PerdaSLA}
        title="s.menu.indicadoroperacao.perdasla"
        isPrivate
        exact
      />
      <Route
        path="/indicadoroperacaoaderencia"
        component={AderenciaProduto}
        title="s.menu.indicadoroperacao.aderenciaproduto"
        isPrivate
        exact
      />

      <Route
        path="/dlgEstoquePostoMonitor"
        component={EstoquePostoMonitor}
        title="Estoque Monitor"
        isPrivate
        exact
      />

      <Route
        path="/dlgEstoquePostoMonitor_fullscreen"
        component={EstoquePostoMonitorFullscreen}
        title="Estoque Monitor"
        isPrivate
        fullScreen
        exact
      />

      <Route
        path="/operacaonotafiscalrecebida"
        component={Notafiscalrecebida}
        title="s.menu.operacao.notafiscalrecebida"
        isPrivate
        exact
      />

      <Route path="/fotonf" component={FotoNF} title="" exact />

      <Route path="/fotonflocal" component={FotoNF} title="" exact />

      <Route
        path="/pitstopjustificativas"
        component={PitStopJustificativa}
        title="s.menu.configuracao.pitstop.justificativa"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemaoperacaoagricola"
        component={MensagemSistemaOperacaoAgricola}
        title="s.menu.cadastro.mensagemsistemaoperacaoagricola"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemamotorista"
        component={MensagemSistemaMotorista}
        title="s.menu.cadastro.mensagemsistemamotorista"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemafrentista"
        component={MensagemSistemaFrentista}
        title="s.menu.cadastro.mensagemsistemafrentista"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemaequipamentoposto"
        component={MensagemSistemaEquipamentoPosto}
        title="s.menu.cadastro.mensagemsistemaequipamentoposto"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemaequipamento"
        component={MensagemSistemaEquipamento}
        title="s.menu.cadastro.mensagemsistemaequipamento"
        isPrivate
        exact
      />

      <Route
        path="/mensagemsistemaposto"
        component={MensagemSistemaPosto}
        title="s.menu.cadastro.mensagemparaposto"
        isPrivate
        exact
      />

      <Route
        path="/perfilfrentistas"
        component={PerfilFrentista}
        title="s.menu.cadastro.usuario.perfilfrentista"
        isPrivate
        exact
      />

      <Route
        path="/relpitstopquantidades"
        component={RelPitStopQuantidade}
        title="s.relatorio.pitstop.quantidades"
        isPrivate
        exact
      />
      <Route
        path="/empresascliente"
        component={EmpresaCliente}
        title="s.cadastro.empresacliente"
        isPrivate
        exact
      />

      <Route
        path="/relentregaproduto"
        component={RelEntregaProduto}
        title=""
        isPrivate
        exact
      />

      {hasModule(MODULO_FERROVIA) && (
        <Route
          path="/relequipamento"
          component={RelEquipamento}
          title="s.relatorio.abastecimentolistagem.equipamentos"
          isPrivate
          exact
        />
      )}

      <Route
        path="/operacaopitstop"
        component={PitStop}
        title="s.menu.operacao.pitstop"
        isPrivate
        exact
      />

      <Route
        path="/locomotivas"
        component={Locomotiva}
        title="s.menu.cadastro.veiculo.locomotiva"
        isPrivate
        exact
      />

      <Route
        path="/uploadplanilhacliente"
        component={Uploadplanilhacliente}
        title="uploadplanilhacliente"
        isPrivate
        exact
      />

      <Route
        path="/configuracaocliente"
        component={ClienteConfig}
        title="Configurações do Cliente"
        isPrivate
        exact
      />
      <Route
        path="/moduloscliente"
        component={ModulosCliente}
        title="Módulos"
        isPrivate
        exact
      />
      <Route
        path="/tagcomrestricao"
        component={TagComRestricao}
        title="s.menu.operacao.tagcomrestricao"
        isPrivate
        exact
      />
      <Route
        path="/afericaodvec"
        component={AfericaoDvec}
        title="s.menu.operacao.afericaodvec"
        isPrivate
        exact
      />
      <Route
        path="/manutencaodvec"
        component={ManutencaoDvec}
        title="s.menu.operacao.manutencaodvec"
        isPrivate
        exact
      />
      <Route
        path="/operacaoedicaoalinhamentotanque"
        component={EdicaoAlinhamentoTanque}
        title="s.menu.operacao.alinhamentotanque"
        isPrivate
        exact
      />
      <Route
        path="/operacaoedicaotrocatanque"
        component={EdicaoTrocaTanque}
        title="s.menu.operacao.trocatanque"
        isPrivate
        exact
      />
      <Route
        path="/operacaoedicaotransferencia"
        component={EdicaoTransferencia}
        title="s.menu.operacao.transferencia"
        isPrivate
        exact
      />
      <Route
        path="/operacaoedicaorecebimentonf"
        component={EdicaoRecebimento}
        title="s.menu.operacao.recebimento"
        isPrivate
        exact
      />
      <Route
        path="/operacaoedicaoturno"
        component={Turno}
        title="s.menu.edicaooperacao"
        isPrivate
        exact
      />
      <Route
        path="/amaggisabastecimentosexternos"
        component={AbastecimentoExterno}
        title="s.menu.operacao.amaggisefazautotrac"
        isPrivate
        exact
      />
      <Route
        path="/reldvecdanificadoparado"
        component={DVECDanificadoParado}
        title="s.menu.relatorio.dvecdanificadoparado"
        isPrivate
        exact
      />
      <Route
        path="/trocastanques"
        component={TrocaTanque}
        title="s.menu.operacao.trocatanque"
        isPrivate
        exact
      />
      <Route
        path="/reldesempenhooperacao"
        component={RelDesempenhoOperacao}
        title="s.menu.relatorio.reldesempenhooperacao"
        isPrivate
        exact
      />
      <Route
        path="/reltrocabateriadbic"
        component={RelTrocaBateriaDbic}
        title="s.menu.relatorio.trocabateriadbic"
        isPrivate
        exact
      />
      <Route
        path="/relhistoricoprecoproduto"
        component={RelPrecoProduto}
        title="s.menu.relatorio.historicoprecoproduto"
        isPrivate
        exact
      />
      <Route
        path="/relhistoricocaddvec"
        component={RelHistoricoCadDVEC}
        title="s.menu.relatorio.relhistoricocaddvec"
        isPrivate
        exact
      />
      <Route
        path="/relhistoricocadtag"
        component={RelHistoricoCadTAG}
        title="s.menu.relatorio.relhistoricocadtag"
        isPrivate
        exact
      />
      <Route
        path="/relinstalacaopin"
        component={RelInstalacaoPin}
        title="s.menu.configuracao.dispositivoinstalacaodvec"
        isPrivate
        exact
      />
      <Route
        path="/reltrocatanque"
        component={RelTrocaTanque}
        title="s.menu.relatorio.reltrocatanque"
        isPrivate
        exact
      />
      <Route
        path="/reldesempenhomodeloveiculo"
        component={RelDesempenhoModeloVeiculo}
        title="s.menu.relatorio.reldesempenhomodeloveiculo"
        isPrivate
        exact
      />
      <Route
        path="/reldesempenholubrificacaoveiculo"
        component={RelDesempenhoLubrificacaoVeiculo}
        title="s.menu.relatorio.reldesempenholubrificacaoveiculo"
        isPrivate
        exact
      />
      <Route
        path="/reldesempenhomotorista"
        component={RelDesempenhoMotorista}
        title="s.menu.relatorio.reldesempenhomotorista"
        isPrivate
        exact
      />
      <Route
        path="/relregimeespecialanglo"
        component={RelRegimeEspecialAnglo}
        title="s.relatorio.relregimeespecialanglo"
        isPrivate
        exact
      />
      <Route
        path="/relalinhamentotanque"
        component={RelAlinhamentoTanque}
        title="s.menu.relatorio.relalinhamentotanque"
        isPrivate
        exact
      />
      <Route
        path="/estoquegeralpostosprodutos"
        component={EstoqueGeralProstosProdutos}
        title="s.menu.operacao.estoquegeralpostoproduto"
        isPrivate
        exact
      />
      <Route
        path="/operduracaobateriasdbics"
        component={OperacaoBateriaDbic}
        title="s.menu.operacao.duracaobateriadbic"
        isPrivate
        exact
      />
      <Route
        path="/relauditoria"
        component={AuditoriaSistemas}
        title="s.menu.relatorio.auditoria"
        isPrivate
        exact
      />
      <Route
        path="/operjustalteracaoencerrante"
        component={JustificativaAlteracaoEncerrante}
        title="s.menu.operacao.justificativaalteracaoencerrante"
        isPrivate
        exact
      />
      <Route
        path="/operjustcontingencia"
        component={JustificativaContingencia}
        title="s.menu.operacao.justificativacontingencia"
        isPrivate
        exact
      />
      <Route
        path="/justtrocamodooperacional"
        component={JustificativaTrocaModoOperacional}
        title="s.configuracao.justificativatrocamodooperacional"
        isPrivate
        exact
      />
      <Route
        path="/configalarmesistema"
        component={AlarmeSistema}
        title="s.configuracao.alarmesistema"
        isPrivate
        exact
      />
      <Route
        path="/operlubrificacao"
        component={OperacaoLubrificacao}
        title="s.menu.operacao.lubrificacao"
        isPrivate
        exact
      />
      <Route path="/demo" component={Demo} title="Demonstração" isPrivate />
      <Route
        path="/perfis"
        component={Perfis}
        title="s.menu.cadastro.usuario.perfil"
        isPrivate
        exact
      />
      <Route
        path="/gerencias"
        component={Gerencias}
        title="s.menu.cadastro.gerencia"
        isPrivate
        exact
      />
      <Route
        path="/causasmanutencoes"
        component={CausasManutencoes}
        title="s.menu.cadastro.causamanutencao"
        isPrivate
        exact
      />
      <Route
        path="/resumosinterfacesterminais"
        component={OperacaoDiagnostico}
        title="s.menu.operacao.diagnostico"
        isPrivate
        exact
      />
      <Route
        path="/safras"
        component={Safras}
        title="s.menu.cadastro.safra"
        isPrivate
        exact
      />
      <Route
        path="/opertotalizadorveiculo"
        component={OperacaoTotalizadorVeiculo}
        title="s.menu.operacao.totalizadorveiculo"
        isPrivate
        exact
      />
      <Route
        path="/operacaolimpezatag"
        component={OperacaoLimpezaTag}
        title="s.operacao.limpezatag"
        isPrivate
        exact
      />
      <Route
        path="/operacaolimpezadvec"
        component={OperacaoLimpezaDvec}
        title="s.operacao.limpezadvec"
        isPrivate
        exact
      />
      <Route
        path="/operacaorecebimentonf"
        component={OperacaoRecebimentoNf}
        title="s.menu.operacao.recebimento"
        isPrivate
        exact
      />
      <Route
        path="/dashboard"
        component={Dashboard}
        title="Dashboard"
        isPrivate
      />
      <Route
        path="/dashboardpadrao"
        component={Dashboard}
        title="Dashboard"
        isPrivate
      />

      <Route path="/blank" component={BlankPage} title="" isPrivate />
      <Route
        path="/motoristas"
        component={Motorista}
        title="s.menu.cadastro.motorista"
        isPrivate
        exact
      />
      <Route
        path="/operacoes"
        component={Operacao}
        title="s.menu.cadastro.operacao"
        isPrivate
        exact
      />

      {hasModule(TRR_CHILE) && (
        <Route
          path="/operacaoabastecimento"
          component={Abastecimento}
          title="s.operacao.entregaproduto"
          isPrivate
          exact
        />
      )}

      {!hasModule(TRR_CHILE) && (
        <Route
          path="/operacaoabastecimento"
          component={Abastecimento}
          title="s.menu.operacao.abastecimento"
          isPrivate
          exact
        />
      )}
      <Route
        path="/operalinhamentotanque"
        component={OperacaoAlinhamentoTanque}
        title="s.menu.operacao.alinhamentotanque"
        isPrivate
        exact
      />
      <Route
        path="/estoqueposto"
        component={OperacaoEstoquePosto}
        title="s.menu.operacao.estoqueposto"
        isPrivate
        exact
      />
      <Route
        path="/estoquetanque"
        component={OperacaoEstoqueTanque}
        title="s.menu.operacao.estoquetanque"
        isPrivate
        exact
      />
      <Route
        path="/operacaorecebimento"
        component={OperacaoRecebimento}
        title="s.menu.operacao.recebimento"
        isPrivate
        exact
      />
      <Route
        path="/operacaovazaonaoautorizada"
        component={OperacaoVazaonaoAutorizada}
        title="s.menu.operacao.vazaonaoautorizada"
        isPrivate
        exact
      />
      <Route
        path="/operacaotransferencia"
        component={Transferencia}
        title="s.menu.operacao.transferencia"
        isPrivate
        exact
      />
      <Route
        path="/operacaoturno"
        component={OperacaoTurno}
        title="s.menu.operacao.turno"
        isPrivate
        exact
      />
      <Route
        path="/contratos"
        component={Contrato}
        title="s.menu.cadastro.veiculo.contrato"
        isPrivate
        exact
      />
      <Route
        path="/centroscustos"
        component={CentroCusto}
        title="s.menu.cadastro.veiculo.centrocusto"
        isPrivate
        exact
      />
      <Route
        path="/cercasvirtuais"
        component={CercasVirtuais}
        title="s.menu.configuracao.cercavirtual"
        isPrivate
        exact
      />
      <Route
        path="/modelosveiculos"
        component={ModeloVeiculo}
        title="s.menu.cadastro.veiculo.modelo"
        isPrivate
        exact
      />
      <Route
        path="/postos"
        component={Posto}
        title="s.menu.configuracao.posto"
        isPrivate
        exact
      />
      <Route
        path="/conversores"
        component={ConversorEntradaSaida}
        title="s.menu.configuracao.conversor"
        isPrivate
        exact
      />
      <Route
        path="/comboios"
        component={Comboio}
        title="s.menu.configuracao.comboio"
        isPrivate
        exact
      />
      <Route
        path="/precosprodutos"
        component={PrecoProduto}
        title="s.menu.operacao.precoproduto"
        isPrivate
        exact
      />
      <Route
        path="/produtos"
        component={Produto}
        title="s.menu.configuracao.produto"
        isPrivate
        exact
      />
      <Route
        path="/arqueacoes"
        component={Arqueacao}
        title="s.menu.configuracao.arqueacao"
        isPrivate
        exact
      />
      <Route
        path="/tanquesfisicos"
        component={TanqueFisico}
        title="s.menu.configuracao.tanquefisico"
        isPrivate
        exact
      />
      <Route
        path="/configalarmetanques"
        component={ConfiguracaoAlarmeTanque}
        title="s.configuracao.alarmetanque"
        isPrivate
        exact
      />
      <Route
        path="/medidores"
        component={Medidores}
        title="s.menu.configuracao.medidor"
        isPrivate
        exact
      />
      <Route
        path="/linhasabastecimentos"
        component={LinhaAbastecimento}
        title="s.menu.configuracao.linhasabastecimentos"
        isPrivate
        exact
      />
      <Route
        path="/terminais"
        component={Terminal}
        title="s.menu.configuracao.terminal"
        isPrivate
        exact
      />
      <Route
        path="/marcasveiculos"
        component={MarcasVeiculo}
        title="s.menu.configuracao.marcasveiculo"
        isPrivate
        exact
      />
      <Route
        path="/empresasveiculos"
        component={EmpresaVeiculo}
        title="s.menu.configuracao.empresaveiculo"
        isPrivate
        exact
      />
      <Route
        path="/relafericao"
        component={Relafericao}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relafericaodvec"
        component={RelAfericaoDvec}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relrecebimento"
        component={Relrecebimento}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/bicos"
        component={Bico}
        title="s.menu.configuracao.bico"
        isPrivate
        exact
      />
      <Route
        path="/relabastecimento"
        component={Relabastecimento}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relabastecimentoa2vf"
        component={RelAbastecimentoA2VF}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relabastecimentocontingencia"
        component={Relabastecimentocontingencia}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relamaggisabastecimentofinal"
        component={RelAbastecimentoFinal}
        title="s.menu.relatorio.amaggi.abastecimentofinal"
        isPrivate
        exact
      />
      <Route
        path="/reldesempenhoveiculo"
        component={ReldesempenhoVeiculo}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relmedicao"
        component={RelMedicao}
        title="s.menu.relatorio.relmedicao"
        isPrivate
        exact
      />
      <Route
        path="/relvazaonaoautorizada"
        component={Relvazaonaoautorizada}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relalteracaoencerrante"
        component={Relalteracaoencerrante}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relextratoproduto"
        component={Relextratoproduto}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relalteracaoestoque"
        component={Relalteracaoestoqueproduto}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relveiculosativos"
        component={RelVeiculosAtivos}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/reldiferencaencerrante"
        component={ReldiferencaEncerrante}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/reltransferencia"
        component={Reltransferencia}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/usuarios"
        component={Usuario}
        title="s.menu.cadastro.usuario.usuario"
        isPrivate
        exact
      />
      <Route
        path="/veiculos"
        component={Veiculo}
        title="s.menu.cadastro.veiculo.veiculo"
        isPrivate
        exact
      />
      <Route
        path="/tanquesvirtuais"
        component={TanqueVirtual}
        title="s.menu.cadastro.tanquevirtual.tanquevirtual"
        isPrivate
        exact
      />
      <Route
        path="/estoqueproduto"
        component={EstoqueProduto}
        title="s.menu.operacao.estoqueproduto"
        isPrivate
        exact
      />
      <Route
        path="/operacaogeolocalizacao"
        component={OperacaoGeolocalizacao}
        title="s.menu.operacao.geolocalizacao"
        isPrivate
        exact
      />
      <Route
        path="/desbloqueiodbic"
        component={DesbloqueioIrregularidadeDbic}
        title="s.operacao.desbloqueiodbic"
        isPrivate
        exact
      />
      <Route
        path="/relrecebimentonf"
        component={Relrecebimentonf}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relresumogeral"
        component={RelResumoGeral}
        title="s.menu.resumogeral"
        isPrivate
        exact
      />
      <Route
        path="/relresumoturno"
        component={Relresumoturno}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relresumooperacao"
        component={Relresumooperacao}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/rellubrificacao"
        component={Rellubrificacao}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relalarmesistema"
        component={Relalarmesistema}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/reltrocamodooperacional"
        component={Relalteracaomodooperacional}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/consultaavancada"
        component={ConsultaAvancada}
        title="Consulta Avançada"
        isPrivate
        exact
      />
      <Route
        path="/localidades"
        component={Localidade}
        title="Localidades"
        isPrivate
        exact
      />
      <Route
        path="/afericoes"
        component={OperacaoAfericao}
        title="Aferição"
        isPrivate
        exact
      />
      <Route
        path="/relcotaempresaveiculo"
        component={RelCotaEmpresaVeiculo}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relcotacontrato"
        component={RelCotaContrato}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/relcotaveiculo"
        component={RelCotaVeiculo}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/dispositivosinstalacoesdvecs"
        component={CadastroDvec}
        title="s.menu.configuracao.dispositivoinstalacaodvec"
        isPrivate
        exact
      />
      <Route
        path="/dashboardcontingenciaabastecimento"
        component={DashboardContingencia}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/dashboarddvec"
        component={DashboardDvec}
        title=""
        isPrivate
        exact
      />
      <Route path="/changesrelease" component={ChangesRelease} title="" exact />
      <Route
        path="/batelada"
        component={OperacaoBatelada}
        title="Batelada"
        isPrivate
        exact
      />
      <Route
        path="/operacaodreno"
        component={OperacaoDreno}
        title="s.menu.operacao.dreno"
        isPrivate
        exact
      />
      <Route
        path="/reldrenagemtanque"
        component={RelDrenagemTanque}
        title="s.relatorio.drenagemtanque"
        isPrivate
        exact
      />
      <Route
        path="/medicaotemperatura"
        component={OperacaoMedicaoTemperatura}
        title="Medição Temperatura"
        isPrivate
        exact
      />
      <Route
        path="/arqueacaoautomatica"
        component={ArqueacaoAutomatica}
        title="Arqueação Automática"
        isPrivate
        exact
      />
      <Route
        path="/relrecebimentonf20"
        component={Relrecebimentonf20}
        title=""
        isPrivate
        exact
      />
      <Route
        path="/sinoticodescarregamentos"
        component={SinoticoDescarregamento}
        title="menu.operacao.sinoticodescarregamentos"
        isPrivate
        exact
      />
      <Route
        path="/sinoticodescarregamentosfull"
        component={SinoticoDescarregamentoFull}
        title="menu.operacao.sinoticodescarregamentos"
        isPrivate
        exact
        full
      />
      <Route
        path="/sinotico-descarregamento"
        component={SinoticoDescarregamentoPreset}
        title="menu.operacao.sinoticodescarregamentos"
        isPrivate
        exact
        full
      />
      <Route
        path="/descarregamentosnaoprocessados"
        component={LogsDescarregamentos}
        title="s.menu.operacao.descarregamentonaoprocessado"
        isPrivate
        exact
      />
      <Route
        path="/operacaoestoqueareia"
        component={EstoqueAreia}
        title="s.menu.operacao.estoqueareia"
        isPrivate
        exact
      />
      <Route
        path="/apuracaoestoqueareia"
        component={ApuracaoEstoqueAreia}
        title="s.menu.operacao.apuracaoestoqueareia"
        isPrivate
        exact
      />
      <Route
        path="/recebimentoareianf"
        component={RecebimentoAreiaNf}
        title="s.menu.operacao.recebimentoareianf"
        isPrivate
        exact
      />
      <Route
        path="/transferenciaareiasilo"
        component={TransferenciaAreiaSilo}
        title="s.menu.operacao.transferenciaareiasilo"
        isPrivate
        exact
      />
      <Route
        path="/afericaoareiasilo"
        component={AfericaoAreiaSilo}
        title="s.menu.operacao.afericaoareiasilo"
        isPrivate
        exact
      />
      <Route path="*" component={NotFound} isPrivate />
    </Switch>
  );
}
